// extracted by mini-css-extract-plugin
export default {"button":"DefaultButton_button__e3RSS","greyButton":"DefaultButton_greyButton__wjNSB","greyText":"DefaultButton_greyText__Htdr7"};